$(document).ready(function(){
    $('.ny-horoscope__slider').owlCarousel({
        autoplay: false,
        loop: true,
        nav: true,
        dots:false,
        margin:25,
        responsive: {
            0: {
                items: 1,
                dots:true,
                nav: false
            },
            360: {
                items: 2,
                dots:true,
                nav: false
            },
            960: {
                items: 3,
                dots:false,
                nav: true
            }
        }
    });

    var predictions = window.predictions || [
        {
            img: 'images/prediction/1.png',
            text: 'Наступающий год принесет изменения в личной жизни. Сперва вам может показаться, что это плохо. Но вскоре вы поймете, как вам повезло!'
        },
        {
            img: 'images/prediction/2.png',
            text: 'В 2020 году вы будете много путешествовать. Не отказывайтесь от любой возможности куда-то поехать, будь то экзотические острова или деревня Бельдяжки. Везде отдых пройдет отлично!'
        },
        {
            img: 'images/prediction/3.png',
            text: 'Не бойтесь принимать решения в наступающем году. Они обязательно изменят вашу жизнь к лучшему!'
        },
        {
            img: 'images/prediction/4.png',
            text: 'В наступающем году есть миллионы шансов встретить любовь всей своей жизни. Активнее смотрите по сторонам!'
        },
        {
            img: 'images/prediction/5.png',
            text: 'Еще не купили лотерею? Зря. В следующем году звезды сулят обогащение на ровном месте. Кстати, это может быть наследство от дальнего родственника или даже принц на белом коне (ну, или принцесса с богатым приданым)!'
        },
        {
            img: 'images/prediction/6.png',
            text: 'Год металлической крысы станет для вас самым счастливым за последние десять лет. Подготовьтесь встретить его во всеоружии!'
        },
        {
            img: 'images/prediction/7.png',
            text: 'Что-то очень хорошее ждет вас в новом году. Только с одним условием: постарайтесь сохранять отличное настроение даже в самые неудачные дни — и судьба щедро наградит вас за позитив!'
        },
        {
            img: 'images/prediction/8.png',
            text: 'Начинайте копить деньги! Не надо пугаться, звезды обещают вам только позитивные моменты, для которых понадобится опустошить банковский счет.'
        },
        {
            img: 'images/prediction/9.png',
            text: 'Активнее впрягайтесь в работу сразу после новогодних каникул. Чем лучше вы себя покажете в этот период, тем больше шансов продвинуться по карьерной лестнице.'
        },
        {
            img: 'images/prediction/10.png',
            text: 'Интересные знакомства, бурные романы, спонтанные путешествия, крупные покупки, успех во всем — выбирайте, что больше нравится! В 2020 году возможно все!'
        },
    ];

    /**
     * Returns a random integer between min (inclusive) and max (inclusive).
     * The value is no lower than min (or the next integer greater than min
     * if min isn't an integer) and no greater than max (or the next integer
     * lower than max if max isn't an integer).
     * Using Math.round() will give you a non-uniform distribution!
     */
    function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function showPrediction() {
        $('.ny-horoscope__ticket-wrapper').removeClass("zoomIn").fadeOut();
        $( ".ny-horoscope__card-ticket" ).fadeIn();
        setTimeout(function(){
            $('.ny-horoscope__card-ticket').fadeOut();
            var prediction = predictions[getRandomInt(0, 9)];
            $('.ny-horoscope__ticket_img img').attr('src', prediction.img)
            $('.ny-horoscope__ticket_content').text(prediction.text);
            $('.ny-horoscope__ticket-wrapper').fadeIn().addClass("animated zoomIn");
        },3000);
    }

    $( ".ny-horoscope__button, .ny-horoscope__ticket_button" ).click(showPrediction);

    $( ".ny-horoscope__ticket-wrapper .fa-times" ).click(function() {
        $('.ny-horoscope__ticket-wrapper').removeClass("zoomIn").fadeOut();
    });
});
